export const localPort = ":5052";
export const version = "v1";
